import React from 'react';
import PropTypes from 'prop-types';
import { VisuallyHidden } from '@react-aria/visually-hidden';
import Link from '../../../Link/Link';


const BasicTemplate = function BasicTemplateComponent({
  title,
  subtitle,
  image,
  linkTo,
  buttonText,
  external,
  imageAltText,
}) {
  return (
    <div className="slot-homepage-hero__wrapper" style={{ backgroundImage: `url("${image}")` }}>
      <VisuallyHidden>
        <img alt={imageAltText} />
      </VisuallyHidden>
      <h1 className="slot-homepage-hero__title">{title}</h1>
      <h2 className="slot-homepage-hero__subtitle">{subtitle}</h2>
      <div className="slot-homepage-hero__button-row">
        <Link
          className="slot-homepage-hero__button"
          href={linkTo}
          external={external}
        >
          {buttonText}
        </Link>
      </div>
    </div>
  );
};

BasicTemplate.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  linkTo: PropTypes.string.isRequired,
  buttonText: PropTypes.string.isRequired,
  external: PropTypes.bool.isRequired,
  imageAltText: PropTypes.string,
};

BasicTemplate.defaultProps = {
  imageAltText: '',
};

export default BasicTemplate;
